import { AlertCircle } from 'lucide-react';

import { DialogTitle, DialogHeader } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { useAddDeposit } from 'src/context/deposit';

const RepoUploadVerificationFailedContainer = () => {
  const {
    ui: { setInitialData, setStep },
  } = useAddDeposit();

  const handleCancel = () => {
    setInitialData();
  };

  const handleRetry = () => {
    setStep('repo');
  };

  return (
    <>
      <DialogHeader className="gap-1.5">
        <DialogTitle className="text-xl flex items-center gap-2">
          <AlertCircle className="size-4 text-destructive" /> Asset format error!
        </DialogTitle>
      </DialogHeader>
      <div className="space-y-6">
        <div className="w-full space-y-4 text-sm">
          <p>
            This ZIP isn&apos;t a valid Git repository. Make sure you cloned the full repository — including the
            main/master branch and the Git metadata (.git directory).
          </p>
        </div>
        <div className="flex justify-end gap-2">
          <Button variant="secondary" onClick={handleCancel}>
            Cancel
          </Button>
          <Button onClick={handleRetry}>Restart upload</Button>
        </div>
      </div>
    </>
  );
};

export default RepoUploadVerificationFailedContainer;
